"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ActionTypes = require("./actionTypes");
function default_1(namespace) {
    const _ActionTypes = ActionTypes.default(namespace);
    function inviteToggleModal() {
        return {
            type: _ActionTypes.TOGGLE_MODAL
        };
    }
    function inviteSelectItem(uuid, itemId) {
        return {
            type: _ActionTypes.SELECT_ITEM,
            payload: {
                uuid,
                itemId
            }
        };
    }
    function addRow(uuid, group, emails, language) {
        return {
            type: _ActionTypes.ADD_ROW,
            payload: {
                uuid,
                group,
                emails,
                language
            }
        };
    }
    function removeRow(uuid) {
        return {
            type: _ActionTypes.REMOVE_ROW,
            payload: {
                uuid
            }
        };
    }
    function updateEmails(uuid, emails) {
        return {
            type: _ActionTypes.UPDATE_EMAILS,
            payload: {
                uuid,
                emails
            }
        };
    }
    function UpdateLanguage(uuid, language) {
        return {
            type: _ActionTypes.UPDATE_LANGUAGE,
            payload: {
                uuid,
                language
            }
        };
    }
    function inviteRequest(items, actions) {
        return {
            type: _ActionTypes.INVITE_REQUEST,
            payload: {
                invitations: items,
                actions
            }
        };
    }
    function inviteSuccess() {
        return {
            type: _ActionTypes.INVITE_SUCCESS
        };
    }
    function inviteFailed(error) {
        return {
            type: _ActionTypes.INVITE_FAILED,
            payload: error
        };
    }
    function inviteValidation(error) {
        return {
            type: _ActionTypes.INVITE_VALIDATION,
            payload: error
        };
    }
    function clear() {
        return {
            type: _ActionTypes.CLEAR
        };
    }
    return {
        inviteToggleModal,
        inviteSelectItem,
        addRow,
        removeRow,
        updateEmails,
        UpdateLanguage,
        inviteRequest,
        inviteSuccess,
        inviteFailed,
        inviteValidation,
        clear
    };
}
exports.default = default_1;
//# sourceMappingURL=actions.js.map